(ns practitest.frontend.components.modal
  (:require ["react-bootstrap/Modal" :as Modal]
            [reagent.core :as reagent]))

(defn bootstrap-modal
  [{:keys [is-open?
           on-request-close
           container-ref
           class
           close-button?
           scrollable?
           centered?
           title-class
           footer-class]
    :as   props}
   header
   body
   footer]
  [:r> Modal
   #js {:show            (boolean is-open?)
        :onHide          on-request-close
        :dialogClassName class
        :scrollable      scrollable?
        :centered        centered?
        :container       (when container-ref
                           (fn []
                             @container-ref))}
   (when header
     [:r> (.-Header Modal) #js {:closeButton (boolean close-button?)}
      [:r> (.-Title Modal) #js {:className title-class}
       (reagent/as-element
         header)]])
   (when body
     [:r> (.-Body Modal) #js {}
      (reagent/as-element
        body)])
   (when footer
     [:r> (.-Footer Modal) #js {:className footer-class}
      (reagent/as-element footer)])])
